'use strict';

/**
 * View for rendering the sets
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeView = require('base/Colido.CompositeView');
var ListItemView = require('./list-item');

var template = require('modules/collection/modules/set/templates/partials/sets-list.hbs');

require('jquery-sly');
require('jquery-humans-dnd');

var SetsListView = CompositeView.extend({
    template: template,

    /**
     * Prepend empty item for input?
     * @type {boolean}
     */
    prependEmpty: true,

    displayImage: true,

    context: 'default',

    childView: ListItemView,

    childViewContainer: '#setsList',

    slider: null,

    /**
     * Options to pass to childView
     * @param [object} model The model
     * @param {int}    index The index of the model
     * @returns {object} The child view options
     */
    childViewOptions: function(model, index) {
        return {
            catalog: this.getOption('catalog'),
            displayImage: this.getOption('displayImage'),
            infiniteView: this.getOption('infiniteView'),
            viewData: {
                path: this.model.getPath(null, {
                    setModel: model,
                    locationModel: null,
                    search: null,
                    filter: null,
                }),
            },
        };
    },

    onRender: function() {
        // @todo: Export this to a better place
        if (this.getOption('infiniteView')) {
            _.delay(function() {
                this.slider = this.$('.sly-frame').sly({
                    horizontal: 1,
                    itemNav: 'basic',
                    speed: 300,
                    mouseDragging: 1,
                    touchDragging: 1,
                    elasticBounds: 1,
                    releaseSwing: 1,
                    scrollBar: this.$('.sly-scroll'),
                    dynamicHandle: 1,
                    dragHandle: 1,
                });
            }.bind(this), 10);
        }

        // Prepend empty model for input?
        if (this.getOption('prependEmpty')) {
            var emptyModel = new this.collection.model({
                _empty: true,
                restricted: !App.user.get('canCreateSet'),
            },{
                collection: this.collection,
            });

            var modelRenderer = new this.childView({
                model: emptyModel,
            });

            if (!this.$(this.childViewContainer).find('.box[data-empty="true"]').length) {
                modelRenderer.render();
                this.$(this.childViewContainer).prepend(modelRenderer.$el);
            }
        }
    },

    onShow: function() {
        if (!this.getOption('infiniteView')) {
            _.delay(function() {
                this.$el.humansDrag({
                    delegate: '.box:not([data-empty="true"])',
                    offset: [5, 5],
                    scrollContainer: ['#content', '.nav-wrapper-talks'],
                    helperClass: 'box-drag-helper',
                    revertClass: 'box-drag-revert',
                    dropClass: 'box-drag-dropped',
                    overDropClass: 'box-drag-overdrop',
                    onDragStart: function (event, humansDrag, element, helper) {
                        // Disable the default link behavior
                        $('html').addClass('has-active-drag has-active-drag-set');

                        element.addClass('box-drag-placeholder');
                        helper.removeAttr('href');
                    }.bind(this),
                    onDragEnd: function (event, humansDrag, element, helper) {
                        $('html').removeClass('has-active-drag has-active-drag-set');

                        // Wait, till element was dropped
                        if (!humansDrag.wasDropped) {
                            window.setTimeout(function () {
                                element.removeClass('box-drag-placeholder');
                            }, 400);
                        } else {
                            element.removeClass('box-drag-placeholder');
                        }
                    }.bind(this),
                });
            }.bind(this), 10);
        }
    },

    onResize: function() {
        if (this.slider && this.slider.sly) {
            this.slider.sly('reload');
        }
    },

    /**
     * Destroy plugins and additional listener
     */
    onBeforeDestroy: function() {
        if (this.getOption('infiniteView')) {
            this.slider && this.slider.sly && this.slider.sly('destroy');
        }

        // Destroy DND
        if (!this.getOption('infiniteView')) {
            this.$el.humansDrag('destroy');
        }
    },

    /**
     * Update sort, after sync
     */
    updateView: function() {
        this.collection.sort();
        if (this.getOption('infiniteView') && this.slider !== null) {
            this.slider.sly('reload');
        }
    },
});

module.exports = SetsListView;